<template>
    <div>
        <h3 style="text-align: center">บันทึกข้อความจากเฮีย / คุณมด</h3>
        <br>
        <div class="row form-group">
            <div class="col-4 text-right">ข้อความ</div>
            <div class="col-7">
                <textarea class="form-control" v-model="form.message"></textarea>
            </div>
        </div>
        <div class="col text-center">
            <button class="btn btn-success" @click="submitData">
                บันทึก
            </button>&nbsp;&nbsp;
            <button class="btn btn-outline-secondary" @click="cancelData">
                ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "RecordMessageModal",
        computed:{
            ...mapState({
                form:state=>{
                    return state.Dashboard.formRecordMessage ;
                },
            }),
        },
        methods:{
            submitData(){
                if(!this.form.message){
                    alert('กรุณาบันทึกข้อความ');
                }else{
                    this.$emit("submit",this.form);
                }
            },
            cancelData(){
                this.$emit("submit",false);
            },
        }
    }
</script>

<style scoped>

</style>
